<template>
  <modal
    id="modalSuprimentoEstoqueTransferenciaDeposito"
    titulo="SUPRIMENTOS.TRANSFERENCIA_DEPOSITOS"
    :exibir="exibir"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <form-estoque :opcoes="opcoes" :form="form" @refs="getRefs" />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar" :disabled="!form.quantidade">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Components:
import FormEstoque from './Form.vue';
import Modal from '@/components/modal/Modal';

//service
import EstoqueService from '@/common/services/estoque/estoque.service';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    opcoes: { type: Object },
  },
  components: {
    Modal,
    FormEstoque,
  },
  data() {
    return {
      refs: [],
      form: {
        produtoId: '',
        depositoAntigoId: '',
        quantidade: null,
        depositoNovoId: '',
        quantidadeTotal: null
      },
    };
  },
  methods: {
    getRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    salvar() {
      if (!this.validarFormulario()) return;
      if (!this.form.quantidadeTotal) {
        mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('ACADEMICO.QUANTIDADE_TOTAL_SEM_ESTOQUE')
        );
        return;
      }
      if (this.form.quantidade > this.form.quantidadeTotal) {
        mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('ACADEMICO.QUANTIDADE_MAIOR_QUANTIDADE_TOTAL')
        );
        return;
      }
      this.$store.dispatch(START_LOADING);
      EstoqueService.transferencia(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('SUPRIMENTOS.TRANSFERENCIA_REALIZADA').formatUnicorn({
              item: this.$t('SUPRIMENTOS.ESTOQUE'),
            })
          );
          this.$emit('tranferenciaDepositoConcluída');
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limpaModal() {
      setTimeout(() => {
        this.form = {
          produtoId: '',
          depositoNovoId: '',
          depositoAntigoId: '',
          quantidade: null,
          quantidadeTotal: null,
        };
      }, 300);
    },
    fecharModal() {
      this.$emit('fechar', 'estoque');
      this.limpaModal();
    },
  },
};
</script>
